import { Component, OnInit } from '@angular/core';
import { AiHintState, AiHintStateService } from '../../services/ai-hint-state.service';

@Component({
  selector: 'app-ai-hint-panel',
  templateUrl: './ai-hint-panel.component.html',
  styleUrls: ['./ai-hint-panel.component.scss'],
  standalone: false
})
export class AiHintPanelComponent implements OnInit {
  state: AiHintState = { hint: '', severity: 'info', field: '', loading: false };
  panelVisible = true;

  constructor(private hintState: AiHintStateService) {}

  ngOnInit(): void {
    this.hintState.state$.subscribe(s => {
      this.state = s;
      // Auto-open panel only when a real hint arrives — skipped fields (no
      // applicable rule) return an empty hint and must not pop the panel open.
      if (s.hint) {
        this.panelVisible = true;
      }
    });
    this.hintState.collapse$.subscribe(() => {
      this.panelVisible = false;
    });
  }

  clearHint(): void {
    this.hintState.clear();
  }
}
